import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/CustomerCareActions';
import DisableCustomerCarePopup from './DisableCustomerCarePopup';

const mapDispatchToProps = (dispatch) => ({
	disableCard: (item) => dispatch(actionLayer.disableCustomerCareUser.request(item)),
	closeModal: () => dispatch(goPopup('')),
	fetchCustomerCareList: (pageSize, pageNumber) => {
		dispatch(
			actionLayer.fetchCustomerCareList.request({
				size: pageSize,
				pageNumber,
				userId: '',
				username: '',
				email: '',
				phone: '',
				groupId: '',
			})
		);
	},
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => state.CustomerCare.isLoading, false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, {}),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DisableCustomerCarePopup);
